export const PLAN_TIER = {
  PLUS: 'plus',
  FREE: 'free',
};
